"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pretensionHistory = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
exports.pretensionHistory = (0, graphql_tag_1.default)`
  ${data_1.pageInfoFields}
  ${data_1.documentSchemaFields}
  ${data_1.userPopupSchemaFields}
  query pretensions_history($pretensionId: Int!, $before: Int, $after: Int, $first: Int, $last: Int) {
    pretensions {
      history(pretensionId: $pretensionId, before: $before, after: $after, first: $first, last: $last) {
        pageInfo {
          ...pageInfoFields
        }
        edges {
          node {
            id
            body
            date
            oldValue
            newValue
            fieldName
            template
            historyType
            systemText
            isRead
            documents {
              ...documentSchemaFields
            }
            bodyDocuments {
              ...documentSchemaFields
            }
            updater {
              ...userPopupSchemaFields
            }
            user {
              ...userPopupSchemaFields
            }
          }
          cursor
        }
      }
    }
  }
`;